/** Выделение из URI значения до # или добавление # */
export const makeHashLastInURI = (uri) => {

  if (uri.lastIndexOf('#')>0){
    return  uri.substring(0, uri.lastIndexOf('#'))
  };

  return uri+'#';
}

/** Выделение имени файла из URL. На основе примера в https://habr.com/ru/articles/510742/
 * Варианты определения пути
 * 1. Последний элемент пути в адресе
 * в остальных случаях - имя хоста
 */
export const parseFileNameFromURL = (url) =>{
  const u = new URL(url);
  //т.е. сразу после хоста 
  if (u.pathname == '/'){
    return u.hostname;
  } else {
    return u.pathname.substring(u.pathname.lastIndexOf('/')+1);
  }
  return u.hostname;
}


/** Формирование URI по вводимых значениях префикса и имени.
 * В имени конечные пробелы удаляются, а внутренние заменяются на _
  */
export const makeURI= (prefix, value)=>{
  return prefix + value.trim().replace(/\s+/g, '_');;
}

/**
 * Выдалание последней части из URI карточки. Варианты:
 * 1. Если есть # - используется часть после #
 * 2. Если есть / - используется последняя часть пути
 * 3. в остальных случаях - имя хоста 
 */
export const lastElementCardURI = (uri) => {
  const u = new URL(uri);
  if (u.hash != "" && u.hash.lastIndexOf('#')>-1)
    return u.hash.substring(u.hash.lastIndexOf('#')+1);
  //т.е. сразу после хоста 
  if (u.pathname != '/')  
    return u.pathname.substring(u.pathname.lastIndexOf('/')+1);

  return u.hostname;
}


/** Формируется Namespace uri SKS на основе URL браузера. 
 * Используется домен первого и второго уровня, третьим - purl. 
 * Заканчивается sksa/ */
export const makeSKSAUriNamespace = () => {
  const { hostname } = window.location;

  const parts = hostname.split(".").filter(Boolean);

  if (parts.length < 2) {
    return `http://purl.${hostname}/sksa/`;
  }

  // Берём домен второго и первого уровня: example.ru, finchainlab.ru и т.п.
  const baseDomain = parts.slice(-2).join(".");

  // Третий уровень делаем "url"
  return `http://purl.${baseDomain}/sksa/`;
};


export const makePrefixIRIByType = (sksaNamespace, typeUri) => {
  if (!sksaNamespace || !typeUri) 
    return sksaNamespace;

  // убираем завершающий / или # из namespace
  const cleanNamespace = sksaNamespace.replace(/[\/#]+$/, "");

  // определяем, какой разделитель использовать в конце
  const endSeparator = sksaNamespace.endsWith("#") ? "#" : "/";

  // убираем завершающий / или # из URI типа
  const cleanTypeUri = typeUri.replace(/[\/#]+$/, "");

  // берём последний элемент после / или #
  const typeName = cleanTypeUri.split(/[\/#]/).pop();

  if (!typeName) {
    return cleanNamespace + endSeparator;
  }

  return `${cleanNamespace}/${typeName}${endSeparator}`;
};